export default "/images/brio.svg?e1c6f2f94230b7301b401dfa099134f8";